import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
  FormField,
  Input,
  Multiselect,
  SegmentedControl,
  ProgressBar,
  StatusIndicator,
  Select,
  Alert,
  Flashbar,
  Checkbox,
  Form,
  Textarea,
  Popover,
  Autosuggest,
  AlertProps,
  Modal,
} from "@cloudscape-design/components";
// import FileUpload from "@cloudscape-design/components/file-upload";
import * as awsui from "@cloudscape-design/design-tokens";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext } from "../context";
import { link } from "fs";
import Series_Drivers from "./series/drivers";
import Series_Teams from "./series/teams";
import Series_Results from "./series/results";
import Series_Calendar from "./series/calendar";
import Series_Rules from "./series/trinations/rules";
import Series_Stats from "./series/stats";
import Series_Livery from "./series/livery";
import { useMediaQuery } from 'react-responsive'
import axios, { AxiosError, AxiosResponse } from 'axios';
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { Amplify, Hub, API } from 'aws-amplify';
import { CognitoUser, CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { CognitoUserSession, ISignUpResult, CognitoAccessToken } from 'amazon-cognito-identity-js'
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { HubCallback } from '@aws-amplify/core/lib/Hub'
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { leagueId } from '../leagueId';
import { LeagueDriver } from '../../../infra/lib/data-classes/league-driver/league-driver.interface';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import { navigateFn } from "../routingHelper";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import DatePicker from '../components/date-picker/DatePicker';
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags'
import SeriesNav from "../components/series-navbar/series-nav";


const apiKey = "2ff73ab3016540b097d3c5cfed50f001f3fb1ce8cf144cc7a9282ee530bb5f2f";
const baseUrl = "https://dev.formularacinggroup.au/api";
const axiosHeaders = { 
  "api-key": apiKey, 
  "Content-Type": "application/json",
}


export function Account() {
  const { 
    theme, setTheme, 
    density, setDensity,
    authInitialState, setAuthInitialState,
    userAttributes, setUserAttributes,
  } = useContext(GlobalContext);
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { user, signOut, toResetPassword } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  const [ oldPassword, setOldPassword ] = useState<string>();
  const [ newPassword, setNewPassword ] = useState<string>();
  const [ confirmNewPassword, setConfirmNewPassword ] = useState<string>();
  const [ passwordResetSuccess, setPasswordResetSuccess ] = useState<boolean | null>();
  const [ passwordResetAlertMessage, setPasswordResetAlertMessage ] = useState<string>();
  
  const [ email, setEmail ] = useState<string>();
  const [ givenName, setGivenName ] = useState<string>();
  const [ familyName, setFamilyName ] = useState<string>();
  const [ name, setName ] = useState<string>();
  const [ profilePicture, setProfilePicture ] = useState<string>();
  const [ dob, setDob ] = useState<string>();
  const [ address, setAddress ] = useState<string>();
  const [ addressPlaceholder, setAddressPlaceholder ] = useState<string>();
  const [ driverId, setDriverId ] = useState<string>();
  const [ irUserId, setIrUserId ] = useState<number>();
  const [ irUserName, setIrUserName ] = useState<string>();
  const [ country, setCountry ] = useState<string>();
  const [ addressUrl, setAddressUrl ] = useState<string>();
  const [ state, setState ] = useState<string>();
  const [ postCode, setPostCode ] = useState<string>();

  const [ username, setUsername ] = useState();
  
  // const [ groups, setGroups ] = useState();
  // const [ state, setState ] = useState();
  // const [ country, setCountry ] = useState();
  // const [ postCode, setPostCode ] = useState();
  // const [ addressUrl, setAddressUrl ] = useState();
  const [ phone, setPhone ] = useState<string>();
  const [ maLicenseId, setMaLicenseId ] = useState<string>();
  const [ discordId, setDiscordId ] = useState<string>();
  const [ carNum, setCarNum ] = useState<string>();
  const [ secondaryCarNum, setSecondaryCarNum ] = useState<string>();
  const [ tertiaryCarNum, setTertiaryCarNum ] = useState<string>();
  const [ driverBio, setDriverBio ] = useState<string>();
  const [ consentToShareInfo, setConsentToShareInfo] = useState<boolean>(true);
  const [ agreeToFrgRules, setAgreeToFrgRules] = useState<boolean>(false);
  const [ notifyEvents, setNotifyEvents ] = useState<boolean>(false);
  const [ irDriverLookupModalVisible, setIrDriverLookupModalVisible ] = useState(false);
  const [ placeDetails, setPlaceDetails ] = useState<any>();
  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    apiKey: "AIzaSyAyAAyFRzCh2NkkvNlLEKmdWHZ1lenQ5nk",
  });
  const options = {
    fields: ["formatted_address", "geometry", "name"],
    strictBounds: false,
    types: ["establishment"],
  };
  // let addressUrl = '';
  // let country = '';
  // let state = '';
  // let postCode = '';

  useEffect(() => {
    // fetch place details for the first element in placePredictions array
    if (placePredictions.length)
      placesService?.getDetails(
        {
          placeId: placePredictions[0].place_id,
        },
        (placeDetails: any) => {
          setPlaceDetails(placeDetails)
        }
      );
  }, [placePredictions]);

  const [{ data: irDriverData, loading: irDriverLoading, error: irDriverError}, getIrDriver] = useAxios({
    url: baseUrl + "/iracing_driver",
    method: "get",
    headers: axiosHeaders,
    params: {}
  }, { 
    manual: true,
  });

  // useEffect(() => {
  //   if (irDriverData != null){
  //     setIrDriverLookupResults(
  //       irDriverData.map( (item:any) => (
  //         { 
  //           label: item.display_name, 
  //           value: item.cust_id 
  //         }
  //       ))
  //     )
  //   }
  // }, [irDriverData]);

  const [{ data: leagueDriver, loading: leagueDriverLoading, error: leagueDriverError}, getLeagueDriver] = useAxios({
    url: baseUrl + "/league-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      method: "get",
      leagueId: leagueId,
      driverId: userAttributes["custom:leagueDriverId"],
    }
  });

  const [{ data: updateLeagueDriver, loading: updateLeagueDriverLoading, error: updateLeagueDriverError}, postLeagueDriver] = useAxios({
    url: baseUrl + "/league-driver",
    method: "post",
    headers: axiosHeaders,
    data: {
      leagueId: leagueId,
      driverId: userAttributes["custom:leagueDriverId"],
      name: name,
      givenName: givenName,
      familyName: familyName,
      email: email,
      phone: phone ? phone : undefined,
      address: address ? address : undefined,
      addressUrl: addressUrl ? addressUrl : undefined,
      country: country ? country : undefined,
      state: state ? state : undefined,
      postCode: postCode ? postCode : undefined,
      dob: dob ? dob : undefined,
      maLicenseId: maLicenseId ? Number(maLicenseId) : undefined,
      irUserId: irUserId ? Number(irUserId) : undefined,
      irUserName: irUserName ? irUserName : undefined,
      discordId: discordId ? discordId : undefined,
      carNum: carNum ? Number(carNum): undefined,
      secondaryCarNum: secondaryCarNum ? Number(secondaryCarNum): undefined,
      tertiaryCarNum: tertiaryCarNum ? Number(tertiaryCarNum): undefined,
      profilePicture: profilePicture ? profilePicture : undefined,
      driverBio: driverBio ? driverBio : undefined,
      consentToShareInfo: consentToShareInfo,
      agreeToFrgRules: agreeToFrgRules,
      notifyEvents: notifyEvents,
    }
  }, {
    manual: true,
  });

  useEffect(() => {
    if (leagueDriver !== undefined) {
      // const userAttributes = user.getSignInUserSession()!.getIdToken().payload
      const username = userAttributes["cognito:username"]
      // const groups = userAttributes["cognito:groups"]
      
      setUsername(username);
      setEmail(userAttributes.email);
      setGivenName(leagueDriver.givenName);
      setFamilyName(leagueDriver.familyName);
      setName(userAttributes.name);
      setProfilePicture(userAttributes.picture);
      // setGroups(groups);
      setDob(leagueDriver.dob);
      setPhone(leagueDriver.phone);
      setAddressPlaceholder(leagueDriver.address);
      setMaLicenseId(leagueDriver.maLicenseId);
      setIrUserId(Number(leagueDriver.irUserId));
      setIrUserName(leagueDriver.irUserName);
      setDiscordId(leagueDriver.discordId);
      setCarNum(leagueDriver.carNum);
      setSecondaryCarNum(leagueDriver.secondaryCarNum);
      setTertiaryCarNum(leagueDriver.tertiaryCarNum);
      setDriverBio(leagueDriver.driverBio);
      if (leagueDriver.consentToShareInfo) setConsentToShareInfo(leagueDriver.consentToShareInfo);
      if (leagueDriver.agreeToFrgRules) setAgreeToFrgRules(leagueDriver.agreeToFrgRules);
      if (leagueDriver.notifyEvents) setNotifyEvents(leagueDriver.notifyEvents);

      // state = leagueDriver.state;
      // country = leagueDriver.country;
      // postCode = leagueDriver.postCode;
      // addressUrl = leagueDriver.addressUrl;
    }
  }, [leagueDriver]);

  useEffect(() => {
    if (placeDetails !== undefined) {
      console.log(placeDetails.url)
      setAddressUrl(placeDetails.url)
      placeDetails.address_components.map( ( item:any ) => {
        if (item.types.includes("country")) setCountry(item.long_name);
        if (item.types.includes("postal_code")) setPostCode(item.long_name);
        if (item.types.includes("administrative_area_level_1")) setState(item.long_name); 
      })
    }
  }, [placeDetails]);

  const passwordResetAlert = (type: AlertProps.Type, message: string) => {
    return (
      <>
        <Alert
          dismissible
          statusIconAriaLabel={type}
          type={type}
          onDismiss={() => {
            setPasswordResetSuccess(null)
          }}
        >
          {message}
        </Alert>
      </>
    );
  }

  const IrDriverLookupModal = () => {
    const [ irDriverLookup, setIrDriverLookup ] = useState('');
    const [ irDriverLookupResults, setIrDriverLookupResults ] = useState([{label: "", value: ""}]);
    
    return (
      <Modal
        onDismiss={() => setIrDriverLookupModalVisible(false)}
        visible={irDriverLookupModalVisible}
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={()=>{setIrDriverLookupModalVisible(false)}}>Cancel</Button>
              <Button variant="primary">Ok</Button>
            </SpaceBetween>
          </Box>
        }
        header="iRacing Driver Lookup"
      >
        <FormField label="iRacing Display Name" stretch >
          <Autosuggest
            onSelect={ ( { detail } ) => {
              console.log(detail)
              // setIrDriverLookup(detail.selectedOption?.description!)
            }}
            onChange={ ( { detail } ) => {
              console.log(detail.value)
              setIrDriverLookup(detail.value);
              // getIrDriver({
              //   params: {irUserName: detail.value}
              // })
            }}
            disableBrowserAutocorrect
            placeholder="Driver Name"
            value={irDriverLookup}
            options={irDriverLookupResults.map((item:any) => (
              {label: item.display_name, value: item.cust_id}
            ))}
            ariaLabel="iRacing Driver Lokkup"
            loadingText="Loading"
            statusType={irDriverLoading ? "loading" : "finished"}
            enteredTextLabel={()=>{return ""}}
          />
        </FormField>
      </Modal>
    )
  }

  return (
    <>
      <center>
        <ContentLayout
          header={
            <div 
              className="account-header-container" 
              style={{ 
                marginTop: "-40px",
                backgroundImage: `url('/images/account/account-header-background.png')`,
                height: "300px",
                maxHeight: "300px",
                maxWidth: "2000px",
                width: "100%",
                zIndex: "3",
                backgroundSize: "cover",
                backgroundPosition: "top right",
                backgroundRepeat: "no-repeat",
              }} 
            />
          }
        >
          <div className="body-content">
            <Container>
              <SeriesNav />
            </Container>
          </div>
        </ContentLayout>
      </center>
      <IrDriverLookupModal />
      <center>
        <div style={{width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content">   
            <div style={{
              maxWidth: "800px"
            }}>     
              { leagueDriverLoading || updateLeagueDriverLoading ? (
                <div style={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                  <RotatingLines
                    width="50%"
                    strokeWidth="10px"
                    strokeColor={awsui.colorBackgroundButtonPrimaryActive}
                    ariaLabel="loading-driver-profile"
                    visible={true}
                  />
                </div>
              ) : (      
                <Form
                  actions={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Button formAction="none" variant="link">
                        Cancel
                      </Button>
                      { agreeToFrgRules ? (
                        <Popover
                        dismissButton={false}
                        position="top"
                        size="medium"
                        triggerType="custom"
                        content={
                          <StatusIndicator type="success">
                            Updated FRG Profile
                          </StatusIndicator>
                        }
                      >
                        <Button 
                          variant="primary"
                          onClick={ () => {
                            postLeagueDriver()
                            // window.location.reload();
                          }}
                        >
                          Update
                        </Button>
                      </Popover>
                      ):(
                        <Popover
                        dismissButton={false}
                        position="top"
                        size="large"
                        triggerType="custom"
                        content={
                          <StatusIndicator type="error">
                            You must agree to the FRG Privacy Policy and Rules!
                          </StatusIndicator>
                        }
                      >
                        <Button 
                          variant="primary"
                          // onClick={ () => {
                          //   postLeagueDriver()
                          // }}
                        >
                          Update
                        </Button>
                      </Popover>
                      )}
                      
                    </SpaceBetween>
                  }
                >
                  <div style={{
                    display: "flex",
                    fontSize: "28px",
                    fontWeight: "bold",
                    alignItems: "center",
                    width: "100%",
                    margin: "20px 0px 20px 0px",
                  }}>
                    Personal Info
                  </div>
                  <SpaceBetween size="xxl">
                    <Grid
                      gridDefinition={[
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 12, } },
                        { colspan: { default: 12, xs: 7, } },
                        { colspan: { default: 12, xs: 5, } },
                        { colspan: { default: 12, xs: 12, } },
                        { colspan: { default: 12, xs: 12, } },
                      ]}
                    >  
                      <FormField label="Username" stretch >
                        <Input
                          // onChange={({ detail }) => {setUsername(detail.value)}}
                          value={username ? username : ""}
                          disabled
                        />
                      </FormField>
                      <FormField label="Email Address" stretch >
                        <Input
                          onChange={({ detail }) => {setEmail(detail.value)}}
                          value={email ? email : ""}
                          type="email"
                          disabled
                        />
                      </FormField>
                      <FormField label="First Name" stretch >
                        <Input
                          onChange={({ detail }) => {setGivenName(detail.value.substring(0, 20))}}
                          value={givenName ? givenName : ""}
                          type="text"
                        />
                      </FormField>
                      <FormField label="Last Name" stretch >
                        <Input
                          onChange={({ detail }) => {setFamilyName(detail.value.substring(0, 20))}}
                          value={familyName ? familyName : ""}
                          type="text"
                        />
                      </FormField>
                      <FormField 
                        label="Address" 
                        stretch 
                        description="Address is intentionally hidden. Enter a new address if you would like to update the FRG records"
                      >
                        <Autosuggest
                          onSelect={ ( { detail } ) => {
                            setAddress(detail.selectedOption?.description!)
                            getPlacePredictions({ input: detail.selectedOption?.description })
                          }}
                          onChange={ ( event ) => {
                            setAddress(event.detail.value.substring(0, 50));
                            getPlacePredictions({ input: event.detail.value });
                          }}
                          disableBrowserAutocorrect
                          placeholder={addressPlaceholder ? addressPlaceholder : "Enter Address"}
                          value={address ? address : ""}
                          options={placePredictions.map((item) => (item))}
                          ariaLabel="Auto select address"
                          loadingText="Loading"
                          key={"autosuggest-address"}
                          statusType={isPlacePredictionsLoading ? "loading" : "finished"}
                          enteredTextLabel={()=>{return ""}}
                        />
                      </FormField>
                      <FormField label="Phone Number" stretch>
                        <PhoneInput
                          placeholder="Enter phone number"
                          value={phone}
                          onChange={ ( event ) => {
                            setPhone(event!.substring(0, 20))
                          }}
                          flags={flags}
                          defaultCountry="AU"
                          addInternationalOption
                        />
                      </FormField>
                      <FormField 
                        label="Date of Birth"
                        stretch
                      >
                        <DatePicker id="date-picker"
                          name='Date of birth'
                          onChange={ ( event ) => {
                            console.log(new Date(event.target.value).toLocaleDateString())
                            setDob(new Date(event.target.value).toLocaleDateString())
                          }}
                          placeholder={new Date(dob ? dob : "now").toLocaleDateString()}
                          value={new Date(dob ? dob : "now").toLocaleDateString()}
                        />  
                      </FormField>
                      <FormField label="Profile Picture" stretch >
                        <Input
                          onChange={({ detail }) => {setProfilePicture(detail.value.substring(0, 100))}}
                          value={profilePicture ? profilePicture : ""}
                          disabled
                          type="url"
                        />
                      </FormField>
                      <FormField label="Driver Bio" stretch >
                        <Textarea
                          onChange={({ detail }) => {setDriverBio(detail.value.substring(0, 200))}}
                          value={driverBio ? driverBio : ""}
                        />
                      </FormField>
                    </Grid>
                    <div style={{
                      display: "flex",
                      fontSize: "28px",
                      fontWeight: "bold",
                      alignItems: "center",
                      width: "100%",
                      margin: "20px 0px 20px 0px",
                    }}>
                      Additional Info
                    </div>
                    {/* <div style={{
                      borderRadius: "8px",
                      padding: "15px",
                      background: "#c8cef7",
                    }}> */}
                      <Grid
                        gridDefinition={[
                          { colspan: { default: 12, xs: 6, } },
                          { colspan: { default: 12, xs: 6, } },
                          // { colspan: { default: 12, xs: 4, } },
                        ]}
                      >
                        <FormField label="iRacing User ID" stretch >
                          <Input
                            onChange={({ detail }) => {setIrUserId(Number(detail.value))}}
                            value={irUserId ? irUserId.toString() : ""}
                            // disabled
                          />
                        </FormField>
                        <FormField label="iRacing Driver Name" stretch>
                          <Input
                            onChange={({ detail }) => {setIrUserName(detail.value)}}
                            value={irUserName ? irUserName : ""}
                            // disabled
                          />
                        </FormField>
                        {/* <div style={{
                          display: "flex",
                          height: "100%",
                          justifyContent: "center",
                          // paddingTop: "20px",
                        }}>
                          <Button
                            variant="normal"
                            onClick={() => setIrDriverLookupModalVisible(true)}
                          >
                            iRacing Driver Lookup
                          </Button>
                        </div> */}
                      </Grid>
                    {/* </div> */}
                    <Grid
                      gridDefinition={[
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 6, } },
                        { colspan: { default: 12, xs: 4, } },
                        { colspan: { default: 12, xs: 4, } },
                        { colspan: { default: 12, xs: 4, } },
                      ]}
                    >
                      <FormField label="Discord User ID" stretch >
                        <Input
                          onChange={({ detail }) => {setDiscordId(detail.value.substring(0, 30))}}
                          value={discordId ? discordId : ""}
                        />
                      </FormField>
                      <FormField label="MA License ID" stretch>
                        <Input
                          onChange={({ detail }) => {setMaLicenseId(detail.value.substring(0, 30))}}
                          value={maLicenseId ? maLicenseId : ""}
                        />
                      </FormField>
                      <FormField label="Car # First Preference" >
                        <Input
                          onChange={({ detail }) => {setCarNum(detail.value.substring(0, 3))}}
                          value={carNum ? carNum : ""}
                          type="number"
                        />
                      </FormField>
                      <FormField label="Car # Second Preference" stretch >
                        <Input
                          onChange={({ detail }) => {setSecondaryCarNum(detail.value.substring(0, 3))}}
                          value={secondaryCarNum ? secondaryCarNum : ""}
                          type="number"
                        />
                      </FormField>
                      <FormField label="Car # Third Preference" stretch>
                        <Input
                          onChange={({ detail }) => {setTertiaryCarNum(detail.value.substring(0, 3))}}
                          value={tertiaryCarNum ? tertiaryCarNum : ""}
                          type="number"
                        />
                      </FormField>
                    </Grid>
                    <Box>
                      <Checkbox
                        onChange={({ detail }) =>
                          setNotifyEvents(detail.checked)
                        }
                        checked={notifyEvents}
                      >
                        Notify me of new and upcoming FRG events
                      </Checkbox>
                      <Checkbox
                        onChange={({ detail }) =>
                          setConsentToShareInfo(detail.checked)
                        }
                        checked={consentToShareInfo}
                      >
                        You consent to allow FRG to share your contact information with sponsors.
                      </Checkbox>
                      <Checkbox
                        onChange={({ detail }) =>
                          setAgreeToFrgRules(detail.checked)
                        }
                        checked={agreeToFrgRules}
                      >
                        You have read and agree to the FRG privacy policy and FRG League Rules.
                      </Checkbox>
                    </Box>
                  </SpaceBetween>
                </Form>
              )}
            </div>
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundContainerContent, width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content" style={{maxWidth: "600px", textAlign: "left"}}>  
            <div style={{ paddingBottom: "20px"}}>
              <h4>Change Password</h4>
              Only FRG account passwords can be reset.
            </div>
            <form onSubmit={(event) => {
              event.preventDefault()
              Auth.currentAuthenticatedUser()
                .then((user) => {
                  return Auth.changePassword(user, oldPassword!, newPassword!);
                })
                .then((data) => {
                  console.log(data)
                  if (data.toUpperCase() === "SUCCESS"){
                    setPasswordResetSuccess(true);
                    setPasswordResetAlertMessage("Successfully changed password")
                  } else {
                    setPasswordResetSuccess(false);
                    setPasswordResetAlertMessage("Failed to changed password")
                  }
                })
                .catch((err) => {
                  console.log(err)
                  setPasswordResetSuccess(false);
                  setPasswordResetAlertMessage(err.toString())
                });
            }}>
              <Form
                actions={
                  <Button variant="normal" formAction="submit">
                    Change Password
                  </Button>
                }
              >
                <Grid
                  gridDefinition={[
                    { colspan: { default: 12, xs: 12, } },
                    { colspan: { default: 12, xs: 12, } },
                    { colspan: { default: 12, xs: 12, } },
                  ]}
                >  
                  <div style={{maxWidth: "400px"}}>
                    Current Password
                    <Input
                      onChange={({ detail }) => setOldPassword(detail.value)}
                      value={oldPassword ? oldPassword : ""}
                      type="password"
                      spellcheck={false}
                    />
                  </div>
                  <div style={{maxWidth: "400px"}}>
                    New Password
                    <Input
                      onChange={({ detail }) => setNewPassword(detail.value)}
                      value={newPassword ? newPassword : ""}
                      type="password"
                      spellcheck={false}
                    />
                  </div>
                  <div style={{maxWidth: "400px"}}>
                    Confirm New Password
                    <Input
                      onChange={({ detail }) => setConfirmNewPassword(detail.value)}
                      value={confirmNewPassword ? confirmNewPassword : ""}
                      type="password"
                      spellcheck={false}
                      invalid={newPassword !== confirmNewPassword}
                    />
                  </div>
                </Grid>
              </Form>
            </form>
            <div style={{ padding: "10px"}}>
              { passwordResetSuccess === true ? passwordResetAlert("success", passwordResetAlertMessage!) : '' }
              { passwordResetSuccess === false ? passwordResetAlert("error", passwordResetAlertMessage!) : '' }
            </div>
          </div>
        </div>
      </center>
    </>    
  );
}

export default withAuthenticator(Account);


